import { useTranslation } from 'react-i18next'

import { useTheme } from 'styled-components'

import { Card, Text } from '@reveni-io/reveni-ui'

import * as Styles from './styles'

const PerformanceInsightsEmptyState = () => {
  const theme = useTheme()
  const { t } = useTranslation()

  return (
    <Card>
      <Styles.ContentContainer>
        <img src="/logos/reveni_icon.svg" alt="Reveni logo" width={100} />
        <Text type="titleM" color={theme.colors.text.muted}>
          {t('Aún no hay datos de ventas')}
        </Text>
      </Styles.ContentContainer>
    </Card>
  )
}

export default PerformanceInsightsEmptyState
